import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type { MailboxInfo } from 'owa-client-types';
import type { FreeBusySessionData } from '../schema/FreeBusySessionData';
import { getFreeBusyCacheStore } from '../store/store';

export function getSessionData(sessionId: string): FreeBusySessionData | undefined {
    return getFreeBusyCacheStore().sessionMap.get(sessionId);
}

export function getSessionMailboxInfo(sessionId: string): MailboxInfo | undefined {
    const sessionStore = getSessionData(sessionId);

    return sessionStore?.mailboxInfo;
}

export function getSessionAttendees(sessionId: string): string[] {
    const sessionStore = getSessionData(sessionId);

    return sessionStore?.attendees ?? [];
}

export function getSessionFilterEvent(sessionId: string): CalendarEvent | undefined {
    const sessionStore = getSessionData(sessionId);

    return sessionStore?.filterEvent ?? undefined;
}
